/* AV-01 contract: direct links; only utm_[a-z]+, fbclid, gclid; default utm_content=av-01.
   Visitor-local data-today dates retain the original formatter and offsets. */
(function () {
  'use strict';
  if (window.nlEditorialLinks) return;
  window.nlEditorialLinks = true;
  var instances = new WeakSet();
  function init(root) {
    if (instances.has(root)) return;
    instances.add(root);
    var keep = /^(utm_[a-z]+|fbclid|gclid)$/;
    var qs = new URLSearchParams(location.search);
    root.querySelectorAll('a[data-nl-cta]').forEach(function (a) {
      var u = new URL(a.href, location.origin);
      qs.forEach(function (v, k) {
        if (keep.test(k) && !u.searchParams.has(k)) u.searchParams.set(k, v);
      });
      if (!u.searchParams.has('utm_content')) u.searchParams.set('utm_content', 'av-01');
      a.href = u.toString();
    });
    var formats = {
      short: { day: 'numeric', month: 'short', year: 'numeric' },
      full: { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' },
      long: { day: 'numeric', month: 'long', year: 'numeric' }
    };
    Array.from(root.getElementsByTagName('span')).forEach(function (el) {
      if (!el.hasAttribute('data-today')) return;
      var d = new Date();
      d.setDate(d.getDate() + (parseInt(el.getAttribute('data-today'), 10) || 0));
      el.textContent = d.toLocaleDateString(document.documentElement.lang || 'en-US', formats[el.getAttribute('data-date-format')] || formats.long);
    });
  }
  function scan(container) {
    if (container.matches && container.matches('[data-nl-editorial]')) init(container);
    container.querySelectorAll('[data-nl-editorial]').forEach(init);
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-nl-editorial]').forEach(function (root) { instances.delete(root); });
  });
})();
